import { IAction } from "@/common/interface";
import { client } from "@q/softCore";
import { applyMiddleware, createStore } from "redux";
import thunk, { ThunkMiddleware } from "redux-thunk";
import { setAppStatus, setAppProgress } from "./actions";
import reducers from "./reducers";

export type IGameState = ReturnType<typeof reducers>;
export * from "./actions";
export const store = createStore(
  reducers,
  applyMiddleware(thunk as ThunkMiddleware<IGameState, IAction>),
);

client.setAppStatus(({ appid = "", stat = 0 }) => {
  store.dispatch(
    setAppStatus({
      [appid]: stat,
    }),
  );
});

client.setDownloadProgress((data) => {
  const { per = 0, speed = 0, appid } = data;
  store.dispatch(
    setAppProgress({
      [appid]: {
        progress: per,
        speed,
        type: "download",
      },
    }),
  );
});

client.setInstallProgress((data) => {
  const { per = 0, speed = 0, appid } = data;
  store.dispatch(
    setAppProgress({
      [appid]: {
        progress: per,
        speed,
        type: "install",
      },
    }),
  );
});
